import { World } from '@brochington/ecstatic';
import { Components } from 'editor/components';
import EventEmitter from 'eventemitter3';

// TODO: It's not yet super clear the best way to architect events.
//       - Maybe Events should extend EventEmitter?
//       - Should the handlers be methods MapSheetEvents?
//       - Does MapSheetEvents need to be it's own component?
//       - What exactly are "Map" events vs "Sheet" events?

class MapSheetEvents extends EventEmitter {
  world: World<Components>;

  // Probably add some sheet details.
  constructor(world: World<Components>) {
    super();

    this.world = world;
  }

  onEventsAdd(world: World<Components>): void {
    // unimplemented.
  }

  onEventsRemove(world: World<Components>): void {
    // unimplemented.
  }
}

export default MapSheetEvents;
